import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Provider } from "app/core/models/provider.model";
import { ProviderService } from 'app/core/services/provider.service';

import { ProviderHeaderComponent } from '../../components/provider-header/provider-header.component';
import { PrescriptionsComponent } from '../../components/prescriptions/prescriptions.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-provider-prescriptions',
    templateUrl: './capture-admin-provider-prescriptions.component.html',
    styleUrls: ['./capture-admin-provider-prescriptions.component.scss'],
    imports: [ProviderHeaderComponent, PrescriptionsComponent, MatProgressSpinner]
})
export class CaptureAdminProviderPrescriptionsComponent implements OnInit {
  private providerService = inject(ProviderService);
  private route = inject(ActivatedRoute);


  provider: Provider;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    const npi = this.route.snapshot.paramMap.get('npi');
    this.loading = true;

    this.providerService.getByNpi(npi).subscribe(provider => {
      this.provider = provider;
      this.loading = false;
    });
  }
}
